import React, { Component } from 'react';
import {
    Form,
    Modal,
    Input,
    message,
    Row,
    Alert,
} from 'antd';
import { connect } from 'react-redux';
import _ from 'lodash';
const FormItem = Form.Item;

class BehaviourMask extends Component {
    constructor(props) {
        super(props); // 调用super父类构造函数改变this指向
        this.state = {
            behaviourDataNew: [],
        };
    }
    componentWillReceiveProps(nextProps) {
        const { editBehavior, behaviourData } = nextProps;
        this.setState({behaviourDataNew: []});
        if (editBehavior) {
            this.changeBehaviourData(behaviourData);
        }
    }
    showBehaviourEdit = data => {
        // 显示编辑行为数据的层
        this.setState({behaviourDataNew: data});
    }
    changeBehaviourData = behaviourData => {
        if (behaviourData) {
            let behaviourDataNew = JSON.parse(behaviourData);
            if ('index' in behaviourDataNew[0]) {
                // 显示编辑页面
                this.showBehaviourEdit(behaviourDataNew);
            } else {
                // 先映射数据，再显示编辑页面
                let len = behaviourDataNew.length;
                let per = parseInt(100 / len);
                let perLast = per + 100 % len;
                behaviourDataNew = behaviourDataNew.map((item, index) => {
                    let begin = 0;
                    let end = 100;
                    let percent = per;
                    if (index === len - 1) {
                        begin = index * per + 1;
                        percent = perLast;
                    } else {
                        begin = index * per + 1;
                        end = (index + 1) * per;
                    }
                    return {index, begin, end, data: item, percent};
                });
                // 显示编辑层
                this.showBehaviourEdit(behaviourDataNew);
            }
        }
    }
    mapBehaviorData = () => {
        const { hideBehaviorMask, changeEditInfo } = this.props;
        const { behaviourDataNew } = this.state;
        this.props.form.validateFields(async (err, fieldsValue) => {
            if (!err) {
                let dataNew = _.chain(fieldsValue)
                    .map((item, i) => {
                        return {percent: parseInt(item), index: parseInt(i)};
                    })
                    .orderBy('index', 'asc')
                    .value();
                let percentTotal = _.sumBy(dataNew, o => o.percent);
                let dataMap = [];
                if (percentTotal != 100) {
                    // 显示提示
                    if (percentTotal < 100) {
                        message.error(`比例设置总和为${percentTotal},小于100，请检查`);
                    } else {
                        message.error(`比例设置总和为${percentTotal},大于100，请检查`);
                    }
                } else {
                    let begin = 1;
                    for (let i = 0, len = dataNew.length; i < len; i++) {
                        let {data} = behaviourDataNew[i];
                        let end = 100;
                        let {percent} = dataNew[i];
                        if (i == 0) {
                            end = percent;
                        } else {
                            let {percent: percentOld} = dataNew[i - 1];
                            begin += percentOld;
                            end = begin + percent - 1;
                        }
                        dataMap.push({begin, end, index: i, data, percent});
                    }
                    // 修改行为数据
                    changeEditInfo({behaviourData: JSON.stringify(dataMap)});
                    hideBehaviorMask();
                }
            }
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const { behaviourDataNew } = this.state;
        const { editBehavior, hideBehaviorMask } = this.props;
        const formItemLayoutNew = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
        };
        return (
            <div>
                <Modal
                    title="编辑行为数据"
                    visible={editBehavior}
                    onOk={this.mapBehaviorData}
                    onCancel={hideBehaviorMask}
                >
                    <Form>
                        {behaviourDataNew.map(item => {
                            return (
                                <div>
                                    <Alert style={{ margin: '16px 0' }} message={`第${item.index + 1}位置:    ${item.data[0][0]}`} />
                                    <FormItem {...formItemLayoutNew} label={`第${item.index + 1}位置行为互动比例`}>
                                        {getFieldDecorator(`${item.index}`, {
                                            initialValue: item.percent,
                                            rules: [
                                                {
                                                    pattern: /^\d+$/,
                                                    message: '请输入正确的行为互动比例',
                                                },
                                            ],
                                        })(<Input addonAfter="%" />)}
                                    </FormItem>
                                </div>
                            )
                        })}
                    </Form>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    ListLoading: state.tasklist.ListStatus.loading,
});

export default connect(mapStateToProps, null)(Form.create()(BehaviourMask));




// WEBPACK FOOTER //
// ./pages/task/tasklist/changeBehaviour.js